import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Switch, Route, Redirect, withRouter, Link } from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import CategoryNavigation from "components/CategoryNavigation/CategoryNavigation.jsx";

import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Search from "@material-ui/icons/Search";

import Check from "@material-ui/icons/Check";

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Input from '@material-ui/core/Input';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import avatar from "assets/img/faces/marc.jpg";

import * as constants from "variables/constants.jsx";
import { doAjax, doAjaxPost, getSettingValueAsBoolean } from "variables/common.js";

const styles = {
  categoriesTree: {
  	width: "100%",
  	columns: "4",
  	'& ul': {
  		paddingLeft: "15px"
  	},
  	'& p': {
  		breakInside: "avoid-column"
  	}
  }
};

class Catalog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoriesTree: []
    }
  }
  
  hanleFilterCatalog = event => {

	var v = document.getElementById("catalogFilter").value;
	v = v.trim().toLowerCase();

	var list = document.querySelectorAll('#categories-tree a');
	
	for (var i in list) {

		var li = list[i];
		
		if (li && li.innerHTML) {
			if (li.innerHTML.toLowerCase().indexOf(v) < 0) { // .innerHTML.find('a')[0]
				li.style.display = 'none';
			} else {
				li.style.display = '';
			}
		}
	};
	
	list = document.querySelectorAll('#categories-tree a');
	for (var i in list) {

		var li = list[i];
		
		var parent = li.parentElement;
		if (parent && parent.parentElement) {
			parent = parent.parentElement;
			if (parent && parent.parentElement) {
				parent = parent.parentElement;
				//  && parent.children && parent.children.children
				if (parent && parent.tagName && parent.tagName.toLowerCase() == 'li') 
				{
					var allHidden = true;
					// parent.children.children
					var children = parent.querySelectorAll('a');
					for (var k in children) {
						var ch = children[k];
						if (ch && ch.tagName && ch.tagName.toLowerCase() == 'a' && ch.style && ch.style.display == '') {
							allHidden = false;
							break;
						}
					}
					if (allHidden) {
						parent.style.display = 'none';
					} else {
						parent.style.display = '';
					}
				}
			}
		
		}
		
	}
  	
  }

  componentDidMount = () => {

    var user = JSON.parse(localStorage.getItem('user')).value;

	//key=' + constants.apiKey + "&principalId=" + user.id + '&upd=' + new Date().getTime() + "&supplierId=" + this.props.supplierId
    var url = constants.apiBaseUrl + '/b2b/supplier/categories?';

    var that = this;

    var cb = function(data) {
	  //console.log("categoriesTree: ", data)

      that.setState({ categoriesTree: data });
      
    };
    
    this.props.handleProgressBarOpen();
    doAjax(url, cb, this.props.handleProgressBarClose, this.props.handleShowSnackbar);
  }

  render() {
    const { classes, i18n, isAdmin, isManager, isClientAdmin, isSupervisor, isWidget } = this.props;
    
    var tabs = this.state.categoriesTree && this.state.categoriesTree.children
            		? this.state.categoriesTree.children.map((masterCategory, index) => ({
                		tabName: masterCategory.data.name,
                		tabId: index + 1,
                		tabContent: <CategoryNavigation categories={masterCategory.children} classes={classes} i18n={i18n} />
           			})) : [];

	if (getSettingValueAsBoolean('PRICELIST_FILTER_SHOW_PROMO', false) && tabs.length > 0) {
		tabs.unshift({
                		tabName: i18n.t('Discounts'),
                		tabId: -1,
                		to: "/pricelist?promo=1",
                		component: {Link},
                		style: {"color": "#f02828"},
                		className: "catalogDiscounts"
          			});
	}				
	
	if (isWidget && tabs.length > 50) {
		return (<div/>);
	}
    
    return (
      <div>
      
      	{isWidget ? (				
			
 			
 			<CustomTabs
				noSelected={true}
				headerColor="info"
				i18n={i18n}
				handleProgressBarOpen={this.props.handleProgressBarOpen}
				handleProgressBarClose={this.props.handleProgressBarClose}
				handleShowSnackbar={this.props.handleShowSnackbar}
				tabs={tabs}
			/>
 						
		  ) : (
			<Card>
          	  <CardBody style={{overflow: "auto", height: "80vh"}}>
          	  
          	  	<div className={classes.searchWrapper}>
		          <CustomInput
		            formControlProps={{
		              className: classes.margin + " " + classes.search,
		              style: {margin: "0px", marginBottom: "20px"}
		            }}
		            id="catalogFilter"
		            inputProps={{
		              placeholder: i18n.t('search'),
		              inputProps: {
		                "aria-label": i18n.t('search')
		              },
		              onKeyUp: event => this.hanleFilterCatalog(event)
		            }}
		          />
		        </div>
          	  
          		<div id="categories-tree" className={ classNames(classes.categoriesTree) }>
          		{this.state.categoriesTree.children && this.state.categoriesTree.children.map(category => {
          			return (
          			<p>
          			{category.children && category.children.length > 0 ?
		          			<b style={{fontSize: "15px"}}>{category.data.name}</b>
		          			: <Link to={'/pricelist?category=' + category.data.name}>
		          			{category.data.name}
		          			</Link>
	          			}
          			
          			
          			<ul>
          			{category.children && category.children.map(category => {
          				return (
	          			<li>
	          			{category.children && category.children.length > 0 ?
		          			category.data.name
		          			: <Link to={'/pricelist?category=' + category.data.name}>
		          			{category.data.name}
		          			</Link>
	          			}
	          			
	          			<ul>
	          			{category.children && category.children.map(category => {
	          				return (
		          			<li>
		          			{category.children && category.children.length > 0 ?
			          			category.data.name
			          			: <Link to={'/pricelist?category=' + category.data.name}>
			          			{category.data.name}
			          			</Link>
		          			}
		          			</li>
		          			)
		          		})
		          		}
	          			</ul>
	          			
	          			</li>
	          			)
	          		})
	          		}
          			</ul>
          			</p>
          			)
          		}
          		
          		)}
          		</div>
          	  </CardBody>
          	</Card>
		  )}
          	
      </div>
    );
  }
}

Catalog.defaultProps = {
	isWidget: false,
}

Catalog.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Catalog);
